import { Logo } from "./Logo.tsx";
import { Menu } from "lucide-react";
import { useAdminSidebarCtx } from "../Admin/useAdminSidebarCtx.ts";
import { SignedInUserMenu } from "./SignedInUser.tsx";
import { AdminLogo } from "../Admin/AdminLogo.tsx";

export function NavBar({
  showAdminSideBarHandle,
}: {
  showAdminSideBarHandle?: boolean;
}) {
  const { openOnMobile } = useAdminSidebarCtx();

  if (!showAdminSideBarHandle) {
    return (
      <header
        className={
          "flex p-2 items-center h-auto md:h-20 bg-white shadow-md shadow-slate-200/30 justify-between gap-2"
        }
      >
        <Logo />
      </header>
    );
  }

  return (
    <header
      className={
        "flex px-4 py-2 items-center h-auto md:h-16 bg-white shadow-md shadow-slate-200/30 justify-between md:justify-end gap-2"
      }
    >
      <div className={"md:hidden"}>
        <AdminLogo />
      </div>
      <div className={"hidden md:block"}>
        <SignedInUserMenu />
      </div>
      <button
        type={"button"}
        onClick={openOnMobile}
        aria-label={"Apri menu"}
        className={"md:hidden p-1 rounded-md hover:bg-slate-100"}
      >
        <Menu className={"w-5"} />
      </button>
    </header>
  );
}
